import React from "react";
/** @jsxImportSource @emotion/react */
import { jsx, css } from "@emotion/react";
import { useEffect } from "react";
import ClearIcon from "@mui/icons-material/Clear";
import { useState, forwardRef } from "react";
import Swal from "sweetalert2";
import axios from "axios";
import { useHistory } from "react-router-dom";
import Loading from "./Loading";
import Layout from "./Layout";
import { DataGrid } from "@mui/x-data-grid";
import AddIcon from "@mui/icons-material/Add";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import Slide from "@mui/material/Slide";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import InputLabel from "@mui/material/InputLabel";
import FormControl from "@mui/material/FormControl";
import ItemEdit from "./ItemEdit";
import pr from "../lib/pr";
import { loginState, configState } from "../lib/State";
import token_login from "../lib/token_login";
import get_session from "../lib/get_session";
import Popover from "@mui/material/Popover";
import Typography from "@mui/material/Typography";
import CloseIcon from "@mui/icons-material/Close";
import { AppBar, Toolbar, IconButton } from "@mui/material";
import CenterSelect from "./CenterSelect";
import LightbulbIcon from "@mui/icons-material/Lightbulb";
import ItemAdd from "./ItemAdd";
import get_login from "../lib/get_login";
import is_admin from "../lib/is_admin";

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

function Coupon() {
  const [login, setLogin] = useState(loginState);
  const [loaded, setLoaded] = useState(false);
  const [rows, setRows] = useState([]);
  const [seq, setSeq] = useState(0);
  const [showAdd, setShowAdd] = useState(false);
  const [showEdit, setShowEdit] = useState(false);
  const token = localStorage.getItem("token");
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [popPhone, setPopPhone] = useState("Hello");
  const [centers, setCenters] = useState([]);
  const [tcid, setTcid] = useState('');

  const open = Boolean(anchorEl);

  const columns = [
    { field: "id", headerName: "id", hide: true },
    { field: "type", headerName: "구분", width: 130, align: "center" },   
    { field: "name", headerName: "상품명", align: "center" , width: 200},
    { field: "origin_price", headerName: "소비자가", align: "center", width: 120 },
    { field: "amount", headerName: "판매가", align: "center", width: 120 },
    { field: "discount_rate", headerName: "할인율", align: "center", width: 70 },
    { field: "pt_count", headerName: "수량", align: "center", width: 70 },
    {
      field: "term",
      headerName: "기간",
      width: 200,
      align: "center",
      renderCell: (params) => {
        return (
          <>
            {params.row.dcount}{params.row.dtype}
          </>
        );
      },
    },
    {
      field: "is_show",
      headerName: "노출",
      width: 90,
      align: "center",
      renderCell: (params) => {
        const color = params.row.is_show !== "1" ? "#3096F4" : "gray";
        return <LightbulbIcon sx={{ color: color }}></LightbulbIcon>;
      },
    },
    {
      field: "is_season",
      headerName: "정기권",
      width: 90,
      align: "center",
      renderCell: (params) => {
        const color = params.row.is_season === "Y" ? "#3096F4" : "gray";
        return <LightbulbIcon sx={{ color: color }}></LightbulbIcon>;
      },
    },
    { field: "cname", headerName: "센터명", width: 180, align: "center" },
  ];

  // const rows = [
  //   {
  //     id: 1,
  //     name: "Snow",
  //     phone: "000-0000-0000",
  //     sex: "남",
  //     age: 35,
  //     weight: 55,
  //   }
  // ];

  const onCloseAddPop = () => {
    setShowAdd(false);
    setTimeout(() => {
      window.location.reload();
    }, 300);
  };

  const onCloseEditPop = () => {
    setShowEdit(false);
    load_data();    
  };

  const onOpenAdd = () => {
    setShowAdd(true);
  };

  // 리스트
  const load_data = async () => {
    console.log("coupon : load_data");
    let result = await axios.post(configState.api + "/gympass_admin/item", {
      token: token,
      cid: login.cid,
      level: login.level,
      mcd: login.mcd,
      tcid: tcid,
    });
    if (result.data.success === 1) {
      setRows(result.data.rows);
    } else {
      Swal.fire(result.data.msg);
      return;
    }
  };

  // ======================= //
  // 로그인
  // ======================= //
  const start = async () => {
    let result;
    result = await get_login();
    setLogin(result.data.login);
    result = await is_admin(result.data.login);
    if (!result) {
      window.location.href = "/";
    }
    setLoaded(true);
  };
  useEffect(() => {
    start();
  }, []);

  // 리스트
  useEffect(() => {
    if (loaded && tcid !== '') {
      load_data();
    }
  }, [loaded,tcid]);

  // 팝업처리
  const onPopoverOver = (event, message) => {
    setPopPhone(message);
    setAnchorEl(event.currentTarget);
  };

  const onPopoverOut = (event) => {
    setAnchorEl(null);
  };

  const onSearchClick = () => {
    load_data();
  } 

  return (
    <>
      {loaded === false ? (
        <Loading></Loading>
      ) : (
        <Layout login={login}>

          {/* 상품추가 팝업 */}
          <Dialog
            open={showAdd}
            fullWidth={true}
            maxWidth="sm"
            TransitionComponent={Transition}
            onClose={() => {}}
          >
            <AppBar sx={{ position: "static" }}>
              <Toolbar>
                <Box sx={{ flexGrow: 1 }}>
                  <Typography style={{ fontSize: 18 }}>상품추가</Typography>
                </Box>
                <IconButton
                  edge="start"
                  color="inherit"
                  onClick={onCloseAddPop}
                  aria-label="close"
                >
                  <CloseIcon />
                </IconButton>
              </Toolbar>
            </AppBar>
            <ItemAdd
              login={login}
              onCloseAddPop={onCloseAddPop}    
              tcidParent={tcid}          
            ></ItemAdd>
          </Dialog>

          <Popover
            id="mouse-over-popover"
            sx={{
              pointerEvents: "none",
            }}
            open={open}
            anchorEl={anchorEl}
            anchorOrigin={{
              vertical: "top",
              horizontal: "left",
            }}
            transformOrigin={{
              vertical: "bottom",
              horizontal: "left",
            }}
            onClose={onPopoverOut}
            disableRestoreFocus
          >
            <Typography sx={{ p: 1 }}>{popPhone}</Typography>
          </Popover>

          <h3
            css={css`
              margin-top: 10px;
            `}
          >
            상품관리
          </h3>

          <Box
            display="flex"
            css={css`
              text-align: right;
              max-width: 1300px;
              margin-bottom: 15px;
            `}
          >
           {/* 센터명 */}
           <CenterSelect                            
              login={login}
              tcidParent={tcid}
              setTcidParent={setTcid}
            />   

            <Button
              sx={{ ml: 1, fontSize:15 }}
              variant="contained"
              onClick={onSearchClick}
              size="small"
            >
              조회
            </Button>
            
            <Box sx={{ flexGrow: 1 }}></Box>

            <Button
              variant="contained"
              color="primary"
              startIcon={<AddIcon />}
              onClick={onOpenAdd}
            >
              상품추가
            </Button>
          </Box>          
         
          <DataGrid
            css={css`
              max-width: 1300px;
              min-height: 550px;
            `}
            rows={rows}
            columns={columns}
            pageSize={10}
            rowsPerPageOptions={[5]}
            checkboxSelection={false}
            onRowClick={(params)=>{
              setSeq(params.row.id);
              setShowEdit(true);
            }}                        
          />          

          {/* 수정하기 팝업 */}
          <Dialog
            open={showEdit}
            TransitionComponent={Transition}
            onClose={() => {}}
            maxWidth="sm"
          >
            <AppBar sx={{ position: "static" }}>
              <Toolbar>
                <Box sx={{ flexGrow: 1 }}>
                  <Typography style={{ fontSize: 18 }}>상품수정</Typography>
                </Box>
                <IconButton
                  edge="start"
                  color="inherit"
                  onClick={onCloseEditPop}
                  aria-label="close"
                >
                  <CloseIcon />
                </IconButton>
              </Toolbar>
            </AppBar>
            <ItemEdit
              login={login}
              seq={seq}
              onClosePop={onCloseEditPop}
            ></ItemEdit>
          </Dialog>

        </Layout>
      )}
    </>
  );
}

export default Coupon;
